
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function TransferStatusCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Transfer Status</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">Transfer functionality temporarily unavailable</p>
      </CardContent>
    </Card>
  );
}
